// extracted by mini-css-extract-plugin
export default {"root":"Factors_root__pYf4w","factor":"Factors_factor__eDFr8","weight":"Factors_weight__B-zWo"};